import equal from "fast-deep-equal";

import articleTypes from "../../articles/constants/articleTypes";
import contributorRoles from "../../articles/constants/contributorRoles";

import { WorkMetaData } from "../types/WorkMetaData";

// Works store bokgruppe as 8x4, articles as 884 (audiobook) or 854 (ebook). Ebooks have no narrators.
export function toArticleValue(key, value, type) {
	if (key === "bokgruppe" && typeof value === "string") {
		return value.replace("x", !type ? "x" : type === articleTypes.EBOOK ? "5" : "8");
	}

	if (key === "contributors" && type === articleTypes.EBOOK) {
		return value?.filter((contributor) => contributor.role !== contributorRoles.NARRATOR);
	}

	return value;
}

export function toArticleData(data, type) {
	return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, toArticleValue(key, value, type)]));
}

export function toWorkValue(key, value) {
	if (key === "bokgruppe" && typeof value === "string") {
		return value.replace(/^8[58](\d)$/, "8x$1");
	}

	return value;
}

export function parseValue(key, value) {
	const result = WorkMetaData.shape[key]?.safeParse(value);

	return result?.success ? result.data : value;
}

export function isValueEqual(key, a, b) {
	return equal(getComparableValue(key, a), getComparableValue(key, b));
}

export function isArticleSynced(key, article, work) {
	return isValueEqual(
		key,
		toArticleValue(key, article[key], article.type),
		toArticleValue(key, work[key], article.type),
	);
}

function getComparableValue(key, value) {
	const parsed = parseValue(key, value);

	return key === "contributors" && Array.isArray(parsed)
		? [...parsed].sort((a, b) => a.role.localeCompare(b.role))
		: parsed;
}
